import { render, staticRenderFns } from "./CustomDrugTrialsConfiguration.vue?vue&type=template&id=5b2f32f5&scoped=true&"
import script from "./CustomDrugTrialsConfiguration.vue?vue&type=script&lang=js&"
export * from "./CustomDrugTrialsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CustomDrugTrialsConfiguration.vue?vue&type=style&index=0&id=5b2f32f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f32f5",
  null
  
)

export default component.exports